import React from 'react';
import { Button } from 'qw-ui-lib-v2';
import I18n from '../../../config/i18n';
import CloseButtonDialog from '../../views/common/CloseButtonDialog';
import {
  enablePageScroll,
  disablePageScroll,
} from '../../common/utils/uiHelper';
import DriveInventoryView from './index';

export default class DrivesModalView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };

    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  handleOpen() {
    disablePageScroll();
    this.setState({ open: true });
  }

  handleClose() {
    enablePageScroll();
    this.setState({ open: false });
  }

  renderChildren() {
    if (this.state.open) {
      return (
        <div className="ml1">
          <DriveInventoryView
            shouldHideDriveTitle={true}
            inventory={this.props.inventory}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }

  render() {
    const actions = [
      <Button key="close" onClick={this.handleClose}>
        {I18n.t('close')}
      </Button>,
    ];

    return (
      <div>
        <CloseButtonDialog
          titleClassName="h4"
          actions={actions}
          title={I18n.t('driveInventory')}
          open={this.state.open}
          modal={false}
          width="80%"
          minHeight="8rem"
          onRequestClose={this.handleClose}
        >
          {this.renderChildren()}
        </CloseButtonDialog>
      </div>
    );
  }
}
